import React, { useState, useEffect } from 'react';
import { Button, Card, Typography } from 'antd';
import { FileUploadButtonWithGenerateIdFormButtonContainer } from './file-upload-with-generate-id-form-button.container';
import { AzureBlobResponse } from '../../../../../shared/file-upload/azure-upload';
import { IdCaseFileUploadButtonWithPreviewContainer } from './id-case-file-upload-button-with-preview.container';
import { Helmet } from 'react-helmet';

const { Title } = Typography;

interface FilesProps {
  shared?: boolean;
  caseId: string;
  isAssigned: boolean;
  onUploadSuccess: (response: AzureBlobResponse, fieldName: string, isPrivate: boolean) => Promise<void>;
  caseState: string;
  isCaseOrApplicant: string;
}

export const Files: React.FC<FilesProps> = (props) => {
  const [isSharedEditing, setIsSharedEditing] = useState(false);
  const [isPrivateEditing, setIsPrivateEditing] = useState(false);

  useEffect(() => {
    setIsSharedEditing(false);
    setIsPrivateEditing(false);
  }, [props.caseState]);

  return (
    <>
      <Helmet>
        <title>{props?.isCaseOrApplicant} - Files</title>
      </Helmet>
      <Card
        hoverable
        style={{
          width: '100%',
          height: '70%',
          marginTop: 20
        }}
      >
        <div className="p-12">
          <div className="flex justify-between items-start">
            <div className="flex flex-col space-y-1">
              <Title level={5}>Shared Files</Title>
              <p>(Visible to Applicant)</p>
            </div>
            <Button
              type="primary"
              disabled={
                !props.isAssigned || props.caseState === 'draft' || props.caseState === 'decisionRendered' || (props.caseState === 'revisionRequested' && props.isAssigned)
              }
              onClick={() => setIsSharedEditing((prev) => !prev)}
            >
              {isSharedEditing ? 'Editing' : 'Edit'}
            </Button>
          </div>

          <div className="flex flex-col space-y-6 mt-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-start w-full">
              <FileUploadButtonWithGenerateIdFormButtonContainer
                title="ID Form"
                fileName="id-form.pdf"
                caseId={props.caseId}
                buttonText={'Upload/Reupload'}
                permittedContentTypes={['application/pdf']}
                permittedExtensions={['pdf']}
                setIsEditing={setIsSharedEditing}
                isPreviewOnly={!isSharedEditing}
                isShowFileName={false}
              />
              <div style={{ margin: '10px' }}>
                <IdCaseFileUploadButtonWithPreviewContainer
                  caseId={props.caseId}
                  title="Notarized ID Form"
                  buttonText={'Upload/Reupload'}
                  permittedContentTypes={['application/pdf']}
                  permittedExtensions={['pdf']}
                  fileName="id-form-notarized.pdf"
                  isPreviewOnly={!isSharedEditing}
                  setIsEditing={setIsSharedEditing}
                  isShowFileName={false}
                  onUploadSuccess={(response: AzureBlobResponse) => props.onUploadSuccess(response, 'notarizedIdForm', false)}
                />
              </div>
            </div>
          </div>
          <div className="flex justify-between items-start">
            <div className="flex flex-col space-y-1">
              <Title level={5} style={{ marginTop: '24px' }}>
                Private Files
              </Title>
              <p>(Not Visible to Applicant)</p>
            </div>
            <Button
              type="primary"
              disabled={
                !props.isAssigned || props.caseState === 'draft' || props.caseState === 'decisionRendered' || (props.caseState === 'revisionRequested' && props.isAssigned)
              }
              onClick={() => setIsPrivateEditing((prev) => !prev)}
            >
              {isPrivateEditing ? 'Editing' : 'Edit'}
            </Button>
          </div>

          <div style={{ margin: '10px' }}>
            <IdCaseFileUploadButtonWithPreviewContainer
              caseId={props.caseId}
              title="Redacted Notarized ID Form"
              buttonText={'Upload/Reupload'}
              permittedContentTypes={['application/pdf']}
              permittedExtensions={['pdf']}
              fileName="id-form-notarized-redacted.pdf"
              isPreviewOnly={!isPrivateEditing}
              setIsEditing={setIsPrivateEditing}
              isShowFileName={false}
              onUploadSuccess={(response: AzureBlobResponse) => props.onUploadSuccess(response, 'redactedNotarizedIdForm', true)}
            />
          </div>
        </div>
      </Card>
    </>
  );
};
